import { useMediaQuery } from '@/hooks/use-media-query';
import styles from './footer-links.module.css';
import { Link } from '@/util/react-router-dom';
import { TranslationKey } from '@/contexts/translations';
import { useTranslation } from '@/contexts/i18n-context';

export interface FooterLink {
  title: TranslationKey;
  to: string;
  isExternal?: boolean;
}

interface FooterLinksProps {
  title?: TranslationKey;
  links: FooterLink[];
}

export function FooterLinks({ title, links }: FooterLinksProps) {
  const isMobile = useMediaQuery('--screen-md');
  const { t } = useTranslation();
  const hasMultipleLinks = links.length > 1;

  return (
    <div className={styles.links}>
      {title && <p className="body-2">{t(title)}</p>}
      {links
        .map((link) => (
          <div key={link.title}>
            <Link
              className={isMobile && hasMultipleLinks ? 'body-3' : 'body-2'}
              {...(link.isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
              to={link.to}
            >
              {t(link.title)}
            </Link>
          </div>
        ))
        .reduce((acc, link) => (
          <>
            {acc}
            <div className={styles.divider} />
            {link}
          </>
        ))}
    </div>
  );
}
